import { render, staticRenderFns } from "./DescuentosReporte.vue?vue&type=template&id=0e610541"
import script from "./DescuentosReporte.vue?vue&type=script&lang=js"
export * from "./DescuentosReporte.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports